import React, { useEffect } from 'react';
import SortCollapse from './SortCollapse';
import PriorityCollapse from './PriorityCollapse';
import CustomCollapse from '../../../../../Components/Common/CustomCollapse';
import FilterCollapse from './FilterCollapse';
import ReplaceCollapse from './ReplaceCollapse';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { addOperationMatches, popOperationMatches, removeOperationMatches, setFeedInfoOperations, setIsChangesMade, setOperation, setOperationMatches, setSelectedOperationIdx, setSelectedOperationName, toggleOperationCaseSensitive } from '../../../../../slices/feeds/reducer';
import { setFeedModalType, toggleAddFieldModal, toggleSelectPathModal } from '../../../../../slices/modals/reducer';
import { loadSource } from '../../../../../slices/feeds/thunk';
import checkPermission from '../../../../../Components/Hooks/PermissionHook';

function OperationCollapse({ idx, name, type, groupPath = "", relativePath = "" }) {
  const dispatch = useDispatch();

  const selectOperationState = createSelector((state) => state.Feed, (state) => ({
    feedInfo: state.feedInfo,
    operations: state.feedInfo.operations,
  }));
  const { operations, feedInfo } = useSelector(selectOperationState);
  let foundOperation = operations.find((item, index) => index === idx);
  const matches = foundOperation.matches;

  function onRemove() {
    const filteredOperations = operations.filter((item, index) => index !== idx);
    dispatch(setFeedInfoOperations(filteredOperations));
    dispatch(setIsChangesMade(true));
  }

  function onDuplicate() {
    dispatch(setFeedInfoOperations([...operations, foundOperation]));
    dispatch(setIsChangesMade(true));
  }

  async function pickGroup() {
    dispatch(setSelectedOperationIdx(idx));
    dispatch(setFeedModalType("operation"));
    // await dispatch(loadSource(feedInfo.source));
    dispatch(toggleSelectPathModal());
    dispatch(setIsChangesMade(true));
  }

  async function pickField() {
    dispatch(setSelectedOperationIdx(idx));
    dispatch(setFeedModalType("operation"));
    // await dispatch(loadSource(feedInfo.source));
    dispatch(toggleAddFieldModal());
    dispatch(setIsChangesMade(true));
  }

  async function handleOperationMatches(e, idx) {
    const [search, replace] = [...e.target.parentElement.querySelectorAll("input[type='text']")];
    await dispatch(addOperationMatches({
      operationIdx: idx,
      search: search.value,
      replace: (replace?.value || ""),
      disabled: false,
    }));
    e.target.blur();
    search.value = "";
    if (replace !== undefined) {
      replace.value = "";
    }
    // e.target.parentElement.parentElement.elements[foundOperation.matches.length].focus();,
    const selectedMatch = e.target.parentElement.parentElement.querySelectorAll(".match")[foundOperation.matches.length];
    selectedMatch.querySelector(`input[name='${e.target.name}']`).focus();
    dispatch(setIsChangesMade(true));
  }

  function changeOperationMatch(e, idx) {
    const [search, replace] = [...e.target.parentElement.querySelectorAll("input[type='text']")];
    if (search.value === "" && (replace === undefined ? true : replace.value === "")) {
      dispatch(removeOperationMatches({ operationIdx: idx, matchIdx: e.target.dataset.id }));
    } else {
      dispatch(setOperationMatches({
        operationIdx: idx,
        matchIdx: search.dataset.id,
        search: search.value,
        replace: (replace?.value || ""),
        disabled: false
      }));
    }
    dispatch(setIsChangesMade(true));
  }

  function handleOperationSelectChange(key, value) {
    dispatch(setOperation({ operationIdx: idx, [key]: value }));
    dispatch(setIsChangesMade(true));
  }

  function handleSwitch(item, operationIdx, matchIdx) {
    dispatch(setOperationMatches(({ operationIdx: operationIdx, matchIdx: matchIdx, disabled: !item })))
  }

  function handleCheck() {
    dispatch(toggleOperationCaseSensitive({ operationIdx: idx }));
    dispatch(setIsChangesMade(true));
  }

  function handleNameChange(e) {
    dispatch(setSelectedOperationName({selectedOperationIdx: idx, name: e.target.innerText}));
    setTimeout(() => {
      const range = document.createRange();
      const selection = window.getSelection();
      
      // Set the cursor to the end of the text content
      range.selectNodeContents(e.target);
      range.collapse(false); // Move the cursor to the end
      selection.removeAllRanges();
      selection.addRange(range);
    }, 1);
  }

  const selectBrandPath = createSelector(state => state.MenuData, state => state.brandPath);
  const brandPath = useSelector(selectBrandPath);

  const canEdit = checkPermission("brands", brandPath, "feedEdit");
  return (
    <React.Fragment>
      {type === "0" || type === "1" ?
        <SortCollapse idx={idx} name={name} caseSensitive={foundOperation.caseSensitive}
          matches={foundOperation.matches} isDisabled={foundOperation.disabled}
          relativePath={relativePath} onRemove={onRemove} onDuplicate={onDuplicate}
          onPickGroup={pickGroup} onPickField={pickField} handleOperationSelectChange={handleOperationSelectChange}
          changeOperationMatch={changeOperationMatch} handleOperationMatches={handleOperationMatches} handleCheck={handleCheck} 
          handleNameChange={handleNameChange} canEdit={canEdit} />
        : type === "2" ?
          <PriorityCollapse idx={idx} name={name} caseSensitive={foundOperation.caseSensitive}
            matches={foundOperation.matches}
            relativePath={relativePath} onRemove={onRemove} onDuplicate={onDuplicate}
            onPickGroup={pickGroup} onPickField={pickField} handleOperationSelectChange={handleOperationSelectChange}
            changeOperationMatch={changeOperationMatch} handleOperationMatches={handleOperationMatches} handleSwitch={handleSwitch} handleCheck={handleCheck}
            handleNameChange={handleNameChange} canEdit={canEdit} />
          : type === "3" || type === "4" ?
            <FilterCollapse idx={idx} name={name} caseSensitive={foundOperation.caseSensitive}
              matches={foundOperation.matches}
              relativePath={relativePath} onRemove={onRemove} onDuplicate={onDuplicate}
              onPickGroup={pickGroup} onPickField={pickField} handleOperationSelectChange={handleOperationSelectChange}
              changeOperationMatch={changeOperationMatch} handleOperationMatches={handleOperationMatches} handleCheck={handleCheck} 
              handleNameChange={handleNameChange} canEdit={canEdit} />
            : type === "5" ?
              <ReplaceCollapse idx={idx} name={name} caseSensitive={foundOperation.caseSensitive}
                matches={foundOperation.matches}
                relativePath={relativePath} onRemove={onRemove} onDuplicate={onDuplicate}
                onPickGroup={pickGroup} onPickField={pickField} handleOperationSelectChange={handleOperationSelectChange}
                changeOperationMatch={changeOperationMatch} handleOperationMatches={handleOperationMatches} handleCheck={handleCheck}
                handleNameChange={handleNameChange} canEdit={canEdit}
              />
              : null}
    </React.Fragment>
  )
}

export default OperationCollapse
